<template>
  <v-dialog v-model="dialog" max-width="100%">
    <v-card>
      <v-toolbar :color="colorDialogTitle" dark>{{ formTitle }}</v-toolbar>
      <v-container fluid>
        <v-form ref="form" v-model="formValid" lazy-validation>
          <template v-if="this.$store.getters.usuario.idRol != 3">
            <v-row justify="center" class="mt-4">
              <v-col cols="12" sm="6">
                <v-select
                  v-model="contratistaSeleccion"
                  :items="listaContratistas"
                  item-value="idContratista"
                  item-text="descripcionContratista"
                  :menu-props="{ maxHeight: '400' }"
                  :rules="[Validaciones.requerido]"
                  :readonly="readonlyContrator"
                  prepend-icon="mdi-badge-account-outline"
                  :label="SeleccionContratista"
                  no-data-text="No se encontraron contratistas"
                  :hint="hintContratista"
                  persistent-hint
                ></v-select>
              </v-col>
            </v-row>
          </template>
          <v-row justify="center" class="mt-4">
            <v-col cols="12" sm="6">
              <v-autocomplete
                v-model="empleadoSeleccionados"
                :items="empleados"
                item-value="idEmpleado"
                item-text="nombreCompleto"
                :rules="[Validaciones.requeridoSelect]"
                attach
                chips
                prepend-icon="mdi-truck"
                label="Personal"
                multiple
                no-data-text="No se encontraron empleados para esta contratista"
                hint="Seleccione hasta 3 empleados que conformarán la cuadrilla"
                persistent-hint
                @input="checkSelectionLimit"
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip color="#cecaff" v-if="index < 2">
                    <span>{{ item.nombreCompleto }}</span>
                  </v-chip>
                  <span
                    v-if="
                      index === empleadoSeleccionados.length - 1 &&
                      empleadoSeleccionados.length > 2
                    "
                    class="grey--text text-caption"
                  >
                    ({{ txtEmpleado }})
                  </span>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row justify="center" class="mt-4">
            <v-col cols="6" class="center">
              <v-card>
                <v-card-title class="justify-center"
                  ><h4>Datos para el ingreso al sistema</h4>
                </v-card-title>
                <v-card-text>
                  <v-row justify="center">
                    <v-col cols="10">
                      <v-text-field
                        v-model="Usuario"
                        :append-icon="'mdi-account'"
                        :rules="[Validaciones.requerido]"
                        label="Usuario"
                        dense
                        outlined
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="10">
                      <v-text-field
                        v-model="password"
                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                        :rules="[Validaciones.requeridopassword]"
                        :type="show1 ? 'text' : 'password'"
                        name="input-10-1"
                        hint="Minimo 6 Caracteres"
                        label="Contraseña"
                        counter
                        dense
                        outlined
                        @click:append="show1 = !show1"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <template v-if="this.colorDialogTitle == 'green'">
                    <v-row justify="center">
                      <span>{{ contraseñaPH }}</span>
                    </v-row>
                  </template>
                  <v-row justify="center">
                    <v-col cols="10">
                      <v-autocomplete
                        v-model="idCajonSeleccionado"
                        :items="cajonesLibres"
                        item-value="idCajon"
                        item-text="idCajon"
                        label="Cajon"
                        height="20"
                        return-object
                        no-data-text="No hay coincidencias"
                        clearable
                        dense
                        outlined
                      ></v-autocomplete>
                      <!-- <v-text-field
                        :append-icon="'mdi-briefcase'"
                        :rules="[Validaciones.requerido]"
                        v-model="NroOT"
                        label="Nro. de OT Mantenimiento"
                        dense
                        outlined
                      ></v-text-field> -->
                      <!-- <v-select
                        v-model="otMantenimientoSeleccion"
                        :items="otMantenimiento"
                        item-value="ord_ot"
                        item-text="ord_ot"
                        :menu-props="{ maxHeight: '400' }"
                        :rules="[Validaciones.requerido]"
                        :readonly="readonlyContrator"
                        prepend-icon="mdi-badge-account-outline"
                        label="Nro de OT Mantenimiento"
                        no-data-text="No se encontraron contratistas"
                        hint="Seleccione la OT de Mantenimiento"
                        persistent-hint
                        :disabled="habilitarSelect"
                      ></v-select>
                    </v-col>
                    <v-col cols="5"> -->
                      <!-- <v-text-field
                        :append-icon="'mdi-briefcase'"
                        :rules="[Validaciones.requerido]"
                        v-model="NroOT"
                        label="Nro. de OT Comercial"
                        dense
                        outlined
                      ></v-text-field> -->
                      <!-- <v-select
                        v-model="otComercialSeleccion"
                        :items="otComercial"
                        item-value="ord_ot"
                        item-text="ord_ot"
                        :menu-props="{ maxHeight: '400' }"
                        :rules="[Validaciones.requerido]"
                        :readonly="readonlyContrator"
                        prepend-icon="mdi-badge-account-outline"
                        label="Nro de OT Comercial"
                        no-data-text="No se encontraron contratistas"
                        hint="Seleccione la OT Comercial"
                        persistent-hint
                        :disabled="habilitarSelect"
                      ></v-select> -->
                    </v-col>
                  </v-row>
                  <v-row justify="center" class="mb-2">
                    <template v-if="colorDialogTitle == 'green'">
                      <v-btn
                        color="primary"
                        :loading="isSaving"
                        depressed
                        @click="editarCuadrilla()"
                      >
                        Guardar Edicion</v-btn
                      >
                    </template>

                    <template v-if="colorDialogTitle == 'indigo'">
                      <v-btn
                        color="primary"
                        :loading="isSaving"
                        depressed
                        @click="crearCuadrilla()"
                      >
                        Guardar</v-btn
                      >
                    </template>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-form>
        <AlertSnackBar ref="AlertSnackBar" color="#7bae00"></AlertSnackBar>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
      </v-card-actions>
    </v-card>

    <dialog-mensaje ref="dialogMensaje" />
  </v-dialog>
</template>
<script>
import dialogMensaje from "@/components/modalMensaje.vue";
import axios from "axios";
import sha512 from "js-sha512";
export default {
  components: {
    dialogMensaje,
  },
  data() {
    return {
      listaContratistas: [],
      cajonesLibres: [],
      idCajonSeleccionado: [],
      empleadosCuadrillaActual: [],
      habilitarSelect: false,
      otMantenimientoSeleccion: "",
      otComercialSeleccion: "",
      otMantenimiento: [],
      otComercial: [],
      colorDialogTitle: "",
      dialog: false,
      formValid: null,
      alertShow: false,
      isSaving: false,
      show1: false,
      hintContratista: "Seleccione el contratista",
      contraseñaPH: "Contraseña",
      readonlyContrator: false,
      SeleccionContratista: "Selección",
      empleados: [],
      empleadoSeleccionados: [],
      contratistas: [],
      contratistaSeleccion: null,
      tipoModal_IdCuadrilla: 0,
      Usuario: "",
      password: "",
      NroOT: "",
      Validaciones: {
        requeridoSelect: (v) =>
          v.length > 0 || "Debe seleccionar al menos un empleado",
        requerido: (v) => !!v || "Campo Requerido",
        requeridopassword: (v) => {
          if (v == null && this.tipoModal_IdCuadrilla === 0) {
            return "Mínimo 6 caracteres";
          }
          if (this.tipoModal_IdCuadrilla === 0) {
            !!v || "Campo Requerido";
          }
          if ((v == null || v === "") && this.tipoModal_IdCuadrilla > 0) {
            return true;
          } else if (v.length < 6) {
            return "Mínimo 6 caracteres";
          }

          return true;
        },
      },
    };
  },
  watch: {
    isSaving(val) {
      if (val) {
        setTimeout(() => (this.isSaving = false), 1500);
      } else {
        this.submitForm();
      }
    },
    async contratistaSeleccion() {
      if (this.tipoModal_IdCuadrilla == 0) {
        this.readonlyContrator = false;
        this.contraseñaPH = "Contraseña";
        this.hintContratista = "Seleccione el contratista";
        this.SeleccionContratista = "Selección";
        await this.getListarEmpleadosContratistasinCuadrillaAsignada();
      } else {
        this.hintContratista = "";
        this.SeleccionContratista = "Contratista de la Cuadrilla Armada";
        this.readonlyContrator = true;
        this.contraseñaPH = "Dejar en blanco si no cambia la Contraseña";
      }
    },
  },
  mounted() {
    if (
      this.$store.getters.usuario.idRol === 3 ||
      this.$store.getters.usuario.idRol === 5
    ) {
      console.log("Ingreso con la cuenta de un contratista");
      this.contratistaSeleccion = this.$store.getters.usuario.idContratista;
      this.getListarCajonesLibres();
      this.getListarEmpleadosContratistasinCuadrillaAsignada();
      this.recuperarOTMantenimiento();
      this.recuperarOTComercial();
      this.getListarContratistas();
      // this.recuperarEmpleadoCuadrilla();
    } else {
      this.getListarContratistas();
    }
  },

  computed: {
    formTitle() {
      return this.tipoModal_IdCuadrilla === 0
        ? "Crear Cuadrilla"
        : "Editar Cuadrilla Nro.: " + this.tipoModal_IdCuadrilla;
    },
    txtEmpleado() {
      return this.empleadoSeleccionados.length - 2 == 1
        ? "+1 empleado"
        : "+" +
            (this.empleadoSeleccionados.length - 2).toString() +
            " empleados";
    },
  },

  methods: {
    checkSelectionLimit() {
      if (this.empleadoSeleccionados.length > 3) {
        this.empleadoSeleccionados.pop();
      }
    },

    async getListarCajonesLibres() {
      // const idContratista =
      //   this.$store.getters.usuario.idContratista == null
      //     ? 2
      //     : this.$store.getters.usuario.idContratista;

      // console.log("El contratista es en getListarCajoneslIbres");
      // console.log(idContratista);

      //this.url = this.$store.getters.urlBase + "Cajon/recuperarCajonesLibres";
      this.url =
        `${this.$store.state.urlBase}Cajon/recuperarCajonesLibres` +
        `?idContratista=${this.$store.getters.usuario.idContratista}&idDistrito=${this.$store.getters.usuario.idDistrito}`;

      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        // params: {
        //   idcontratista:
        //     this.$store.getters.usuario.idRol != 3
        //       ? this.contratistaSeleccion
        //       : this.$store.getters.idContratista,
        // },
        url: this.url,
      };

      var obj = {
        idContratista: this.idContratista,
        idDistrito: this.$store.getters.usuario.idDistrito,
      };

      var respuesta = await axios(this.url, obj, options);
      if (respuesta.status === 200) {
        console.log("la lista de cajones libres es:");
        console.log(respuesta.data);
        this.cajonesLibres = respuesta.data;
        // this.getListarDiasMantenimiento();
      } else {
        // this.colorSnack = "red";
        // this.mensajeSnack = respuesta.data;
        // this.Showsnackbar = true;
        console.log("Error");
      }
    },

    async getListarCuadrillaByContratista() {
      console.log("getListarCuadrillaByContratista");
      console.log(this.$store.getters.usuario.idContratista);

      // Construir la URL con parámetros de consulta
      const idUsuario = this.$store.getters.usuario.user_id;
      const idEmpresa = this.$store.getters.usuario.idContratista;

      this.url = `${this.$store.getters.urlBase}Cuadrilla?idUsuario=${idUsuario}&idEmpresa=${idEmpresa}`;
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        // params: {
        //   idcontratista:
        //     this.$store.getters.usuario.idRol != 3
        //       ? this.contratistaSeleccion
        //       : this.$store.getters.idContratista,
        // },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      if (respuesta.status === 200) {
        console.log("la lista de cuadrilla es:");
        console.log(respuesta.data);
        this.cuadrillas = respuesta.data;
        // this.getListarDiasMantenimiento();
      } else {
        // this.colorSnack = "red";
        // this.mensajeSnack = respuesta.data;
        // this.Showsnackbar = true;
        console.log("Error");
      }
    },

    async crearCuadrilla() {
      this.url = this.$store.getters.urlBase + "Cuadrilla/ingresarCuadrilla";

      var ots = [];
      var IdOT;
      var Tipo;

      console.log("EL personal seleccionado es:");
      console.log(this.empleadoSeleccionados);

      if (this.empleadoSeleccionados.length == 0) {
        this.$refs.dialogMensaje.abrirMensajeDialog(
          "No ha ingresado ningun empleado en la cuadrilla",
          1,
          "red",
          "Aviso"
        );
        return;
      }

      if (this.Usuario == "") {
        this.$refs.dialogMensaje.abrirMensajeDialog(
          "No ha ingresado el nombre de la cuenta",
          1,
          "red",
          "Aviso"
        );
        return;
      }

      if (this.password == "") {
        this.$refs.dialogMensaje.abrirMensajeDialog(
          "No ha ingresado la contraseña",
          1,
          "red",
          "Aviso"
        );
        return;
      }

      if (this.otMantenimientoSeleccion != null) {
        IdOT = this.otMantenimientoSeleccion;
        Tipo = "M";
        ots.push({ IdOT: IdOT, Tipo: Tipo });
      }

      if (this.otComercialSeleccion != null) {
        IdOT = this.otComercialSeleccion;
        Tipo = "C";
        ots.push({ IdOT: IdOT, Tipo: Tipo });
      }

      console.log("Las ot son");
      console.log(ots);

      console.log("El cajon seleccionado es:");
      console.log(this.idCajonSeleccionado);

      const params = {
        idUsuario: this.$store.getters.usuario.user_id,
        idEmpresa:
          this.$store.getters.usuario.idContratista == null
            ? 2
            : this.$store.getters.usuario.idContratista,
        cuenta: this.Usuario,
        contraseña: sha512(this.password),
        personalCuadrillaI: this.empleadoSeleccionados,
        //PersonalCuadrilla: this.empleadoSeleccionados,
        idCajon:
          this.idCajonSeleccionado.idCajon == "" ||
          this.idCajonSeleccionado.idCajon == null ||
          this.idCajonSeleccionado.idCajon == undefined
            ? 0
            : this.idCajonSeleccionado.idCajon,
        idDistrito: this.$store.getters.usuario.idDistrito,
      };

      console.log("Los datos de las cuadrillas para ingresar son");
      console.log(params);

      await axios
        .post(this.url, params)
        .then((response) => {
          console.log("Las respuesta de ingresa cuadrilla es: ");
          console.log(response.data);
          if (response.data == false) {
            this.$refs.dialogMensaje.abrirMensajeDialog(
              "Ya existe una cuenta de usuario con el mismo nombre",
              1,
              "red",
              "Aviso"
            );
          } else {
            this.$router.push({
              name: "Cuadrilla",
            });

            this.$refs.dialogMensaje.abrirMensajeDialog(
              "Operacion Exitosa",
              1,
              "green",
              "Mensaje"
            );
          }
          this.otMantenimiento = response.data;
        })
        .catch((error) => {
          console.log(error.response);
          console.log("Ya existe una cuenta de usuario con el mismo nombre");
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
        });

      // if (
      //   this.idCajonSeleccionado.idCajon != null &&
      //   this.idCajonSeleccionado.idCajon != ""
      // ) {
      //   this.ingresarRemitoEntrega();
      // }

      this.loadingButton = false;
      this.$emit("recargarListado");
    },

    async getListarContratistas() {
      console.log("Ingreso en listar contratistas");
      // this.url = "https://localhost:5001Contractor/getlistado";
      this.url =
        this.$store.getters.urlBase +
        "Contractor/recuperarContratistasAsociados?idUsuario=" +
        this.$store.getters.usuario.user_id;
      // const config = {
      //   headers: {
      //     Authorization: `Bearer ${this.$store.getters.usuario.token}`,
      //   },
      // };

      //var listacontratistas = [];

      await axios
        .get(this.url)
        .then((response) => {
          console.log(response.data);
          this.listaContratistas = response.data;
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
        });
      this.loadingButton = false;
    },

    async ingresarRemitoEntrega() {
      this.url = this.$store.getters.urlBase + "Remito/ingresarRemitoEntrega";

      const remito = {
        idCuadrilla: this.tipoModal_IdCuadrilla,
        idCajon: this.idCajonSeleccionado.idCajon,
        idUsuario: this.$store.getters.usuario.user_id,
        idContratista: this.$store.getters.usuario.idContratista,
      };

      // var params = {
      //   remito: remito,
      // };

      console.log("Los parametros son:");
      console.log(remito);

      await axios.post(this.url, remito).then((response) => {
        console.log("Las respuesta de ingresa cuadrilla es: ");
        console.log(response.data);
        if (response.data == false) {
          this.$refs.dialogMensaje.abrirMensajeDialog(
            "Ya existe un remito con el mismo numero",
            1,
            "red",
            "Aviso"
          );
        } else {
          this.$refs.dialogCuadrilla.abrirCuadrillaDialog(
            "Operacion Exitosa",
            1,
            "green",
            "Ok"
          );
        }
        this.otMantenimiento = response.data;
      });

      this.loadingButton = false;

      this.dialog = false;

      this.$emit("recargarListado");
    },

    async recuperarEmpleadoCuadrilla() {
      this.url =
        this.$store.getters.urlBase +
        "Cuadrilla/recuperarPersonalCuadrilla?idCuadrilla=" +
        this.tipoModal_IdCuadrilla;

      var respuesta = await axios
        .get(this.url)
        .then((response) => {
          this.empleadosCuadrillaActual = response.data;
          return response.data;
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
        });

      this.empleadosCuadrillaActual = respuesta;
      console.log("Los empleados de la cuadrilla son: ");
      console.log(this.empleadosCuadrillaActual);
    },

    async editarCuadrilla() {
      this.url = this.$store.getters.urlBase + "Cuadrilla/editarCuadrilla";

      var ots = [];
      var IdOT;
      var Tipo;

      if (this.otMantenimientoSeleccion != null) {
        IdOT = this.otMantenimientoSeleccion;
        Tipo = "M";
        ots.push({ IdOT: IdOT, Tipo: Tipo });
      }

      if (this.otComercialSeleccion != null) {
        IdOT = this.otComercialSeleccion;
        Tipo = "C";
        ots.push({ IdOT: IdOT, Tipo: Tipo });
      }

      //console.log("Las ot son");
      //console.log(ots);

      console.log("Los empleados seleccionados para la edicion son : ");
      console.log(this.empleadoSeleccionados);
      console.log(this.empleadosCuadrillaActual);
      var empleadosEditados = this.empleadoSeleccionados
        .filter((empleado) => empleado !== null && empleado !== undefined)
        .map((empleado) => ({ ...empleado, estado: 1, dni: empleado }));

      console.log("Los empleados editados son: ");
      console.log(empleadosEditados);

      // Crear un conjunto de DNIs de empleados en empleadosEditados
      const dnisEmptySet = new Set(
        empleadosEditados.map((empleado) => empleado.dni)
      );

      // Filtrar empleados en empleadosCuadrillaActual cuyos DNIs no están en empleadosEditados
      const empleadosFaltantes = this.empleadosCuadrillaActual
        .filter((empleado) => !dnisEmptySet.has(empleado.dni))
        .map((empleado) => ({ estado: 0, dni: empleado.dni }));

      // Agregar los empleados faltantes a empleadosEditados
      const empleadosEditadosActualizados = [
        ...empleadosEditados,
        ...empleadosFaltantes,
      ];

      console.log("Los empleado editados son");
      console.log(empleadosEditadosActualizados);

      console.log("El cajon seleccionado para asignarle a la cuadrilla es: ");
      console.log(this.idCajonSeleccionado.idCajon);
      const params = {
        idCuadrilla: this.tipoModal_IdCuadrilla,
        PersonalCuadrilla: empleadosEditadosActualizados,
        cuenta: this.Usuario,
        contraseña:
          this.password == null || this.password == ""
            ? null
            : sha512(this.password),
        idCajon:
          this.idCajonSeleccionado.idCajon == null ||
          this.idCajonSeleccionado.idCajon == "" ||
          this.idCajonSeleccionado.idCajon == undefined
            ? 0
            : this.idCajonSeleccionado.idCajon,
        idUsuario: this.$store.getters.usuario.user_id,
      };

      await axios
        .post(this.url, params)
        .then((response) => {
          //console.log("Las ot mantenimiento son: ");
          console.log(response.data);
          this.otMantenimiento = response.data;
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
        });

      if (
        this.idCajonSeleccionado.idCajon != null &&
        this.idCajonSeleccionado.idCajon != ""
      ) {
        await this.ingresarRemitoEntrega();
      }

      this.loadingButton = false;

      this.dialog = false;

      this.$emit("recargarListado");
    },

    async recuperarOTMantenimiento() {
      // this.url = "https://localhost:5001Contractor/getlistado";
      this.url = this.$store.getters.urlBase + "OT/recuperarOTsMantenimiento";
      // const config = {
      //   headers: {
      //     Authorization: `Bearer ${this.$store.getters.usuario.token}`,
      //   },
      // };

      this.otMantenimiento = [];

      await axios
        .get(this.url)
        .then((response) => {
          console.log("Las ot mantenimiento son: ");
          console.log(response.data);
          this.otMantenimiento = response.data;
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
        });
      this.loadingButton = false;
    },

    async recuperarOTComercial() {
      this.url = this.$store.getters.urlBase + "OT/recuperarOTsComerciales";
      // const config = {
      //   headers: {
      //     Authorization: `Bearer ${this.$store.getters.usuario.token}`,
      //   },
      // };

      this.otComercial = [];

      await axios
        .get(this.url)
        .then((response) => {
          console.log("Las ot comerciales son: ");
          console.log(response.data);
          this.otComercial = response.data;
        })
        .catch((error) => {
          console.log(error.response);
          if (error.response == undefined) {
            this.mensajeSnack = "Error de Conexion";
          } else {
            if (error.response.status === 401) {
              this.mensajeSnack =
                "No posee autorizacion para ver esta informacion";
            } else {
              if (error.response.data != "") {
                this.mensajeSnack = error.response.data;
              }
            }
          }
          this.loadingButton = false;
          this.colorSnack = "red";
          this.Showsnackbar = true;
        });
      this.loadingButton = false;
    },

    pruebaReset() {
      this.$refs.form.reset();
    },
    async openModal(tipo) {
      this.habilitarSelect = false;
      this.colorDialogTitle = "indigo";
      this.tipoModal_IdCuadrilla = tipo;
      if (this.tipoModal_IdCuadrilla != 0) {
        this.getCuadrillabyID(tipo);
      } else {
        this.empleados = [];
        this.contratistaSeleccion = [];
      }

      if (
        this.$store.getters.usuario.idRol === 3 ||
        this.$store.getters.usuario.idRol === 5
      ) {
        console.log("Ingreso con la cuenta de un contratista");
        this.contratistaSeleccion = this.$store.getters.usuario.idContratista;
        await this.getListarCajonesLibres();
        await this.getListarEmpleadosContratistasinCuadrillaAsignada();
        await this.recuperarOTMantenimiento();
        await this.recuperarOTComercial();
        // this.recuperarEmpleadoCuadrilla();
      } else {
        await this.getListarContratistas();
      }

      this.dialog = true;
    },
    async openModalModificacion(datos) {
      this.empleadoSeleccionados = [];
      this.empleados = [];
      this.Usuario = datos.nombreCuadrilla;
      console.log("El nombre de usuario de la cuadrilla es ");
      console.log(this.Usuario);
      this.colorDialogTitle = "green";
      this.habilitarSelect = true;
      console.log("Los datos de la cuadrilla enviada son: " + datos);
      console.log(datos);
      this.tipoModal_IdCuadrilla = datos.idCuadrilla;
      if (this.tipoModal_IdCuadrilla != 0) {
        await this.getCuadrillabyID(datos.idCuadrilla);
        await this.recuperarEmpleadoCuadrilla();
      } else {
        this.empleados = [];
        this.contratistaSeleccion = [];
      }
      this.dialog = true;

      console.log("El valor de habilitar");
      console.log(this.habilitarSelect);
      //this.recuperarEmpleadoCuadrilla();
    },
    close() {
      this.dialog = false;
      this.tipoModal_IdCuadrilla = 0;
      this.$refs.form.reset();
    },
    submitForm() {
      this.dialog = false;
      this.$refs.form.reset();
      this.$emit("Recargar");
    },
    // async getListarContratistas() {
    //   // this.url = "https://localhost:5001Contractor/getlistado";
    //   this.url = this.$store.getters.urlBase + "Contractor/recuperarContratistasAsociados?idUsuario=" +
    //this.$store.getters.usuario.user_id
    //   // const config = {
    //   //   headers: {
    //   //     Authorization: `Bearer ${this.$store.getters.usuario.token}`,
    //   //   },
    //   // };

    //   var listacontratista = [];
    //   this.contratistas = listacontratista;

    //   await axios
    //     .get(this.url)
    //     .then((response) => {
    //       console.log(response.data);
    //       this.contratistas = response.data;
    //     })
    //     .catch((error) => {
    //       console.log(error.response);
    //       if (error.response == undefined) {
    //         this.mensajeSnack = "Error de Conexion";
    //       } else {
    //         if (error.response.status === 401) {
    //           this.mensajeSnack =
    //             "No posee autorizacion para ver esta informacion";
    //         } else {
    //           if (error.response.data != "") {
    //             this.mensajeSnack = error.response.data;
    //           }
    //         }
    //       }
    //       this.loadingButton = false;
    //       this.colorSnack = "red";
    //       this.Showsnackbar = true;
    //     });
    //   this.loadingButton = false;
    // },
    orderList() {
      this.list = this.list.sort((one, two) => {
        return one.order - two.order;
      });
    },
    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;
      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      );
    },

    async getListarEmpleadosContratistasinCuadrillaAsignada() {
      console.log("El contratista seleccionado es");
      console.log(this.contratistaSeleccion);

      this.url = this.$store.getters.urlBase + "Employee/getlistByContrator";
      // this.$store.getters.urlBase + "Employee/getlistByContrator";
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        params: {
          idContratista:
            this.$store.getters.usuario.idRol != 3 ||
            this.$store.getters.usuario.idRol != 5
              ? this.contratistaSeleccion
              : this.$store.getters.usuario.idContratista,
          idDistrito: this.$store.getters.usuario.idDistrito,
        },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      console.log("Los empleado del contratista son");
      console.log(respuesta.data);

      if (respuesta.status === 200) {
        this.empleados = respuesta.data;
      }
    },
    async getCuadrillabyID(idCuadrilla) {
      this.url = this.$store.getters.urlBase + "Gang/GetActiveGangById";
      const options = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        params: { idGang: idCuadrilla },
        url: this.url,
      };
      var respuesta = await axios(this.url, options);
      if (respuesta.status === 200) {
        this.contratistaSeleccion = respuesta.data.idEmpresa;
        //this.Usuario = respuesta.data.cuenta;
        this.NroOT = respuesta.data.idOT;
        console.log("los datos de getCuadrillabyID");
        console.log(respuesta.data.empleados);
        this.empleadosCuadrillaActual = respuesta.data.empleados;
        console.log(this.empleadosCuadrillaActual);
        await this.getListarEmpleadosContratistasinCuadrillaAsignada();

        respuesta.data.empleados.forEach((element) => {
          this.empleados.push({
            idEmpleado: element.dni,
            nombreCompleto: element.apellido + " " + element.nombre,
          });
          this.empleadoSeleccionados.splice(1, 0, element.dni);
        });
      } else {
        this.colorSnack = "red";
        this.mensajeSnack = respuesta.data;
        this.Showsnackbar = true;
      }

      //Aqui recupero las ot

      this.url =
        this.$store.getters.urlBase +
        "OT/recuperarOTsXCuadrilla?idCuadrilla=" +
        this.tipoModal_IdCuadrilla;
      const options1 = {
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
        params: { idGang: idCuadrilla },
        url: this.url,
      };
      respuesta = await axios(this.url, options1);
      if (respuesta.status === 200) {
        console.log("La respuesta de las ot son");
        console.log(respuesta.data);
        respuesta.data.forEach((item) => {
          const tipo = item.tipo;
          console.log("El codigo de orden es: ");
          console.log(item.ord_ot);
          console.log("El tipo de orden es: ");
          console.log(item.tipo);

          if (tipo == "M") {
            this.otMantenimientoSeleccion = item.ord_ot;
            console.log("La ot mantenimiento elejida es");
            console.log(this.otMantenimientoSeleccion);
          }
          if (tipo == "C") {
            this.otComercialSeleccion = item.ord_ot;
            console.log("La ot comercial elejida es");
            console.log(this.otComercialSeleccion);
          }
        });
      } else {
        this.colorSnack = "red";
        this.mensajeSnack = respuesta.data;
        this.Showsnackbar = true;
      }

      // console.log("La ot comercial elejida es");
      // console.log(this.otComercialSeleccion);

      // if (respuesta.data.tipo == "C") {
      //   this.otComercialSeleccion = respuesta.data.tipo;
      // }
      // if (respuesta.data.tipo == "M") {
      //   this.otMantenimientoSeleccion = respuesta.data.tipo;
      // }
    },
    OptionSave() {
      if (this.tipoModal_IdCuadrilla === 0) {
        console.log(this.empleadoSeleccionados);
        this.InsertarCuadrilla();
      } else {
        console.log(this.empleadoSeleccionados);
        this.UpdateCuadrilla();
      }
    },
    async UpdateCuadrilla() {
      if (this.$refs.form.validate()) {
        this.url = this.$store.getters.urlBase + "Gang/updategang";

        console.log("Los empleados seleccionados son: ");
        console.log("");

        var gangModel = {
          GangID: this.tipoModal_IdCuadrilla,
          EmployeesId: this.empleadoSeleccionados,
          Password: this.password,
          Account: this.Usuario,
          OTId: this.NroOT,
        };
        const config = {
          headers: {
            Authorization: `Bearer ${this.$store.getters.usuario.token}`,
          },
        };
        await axios
          .post(this.url, gangModel, config)
          .then(
            (response) => (this.respuesta = response),
            (this.isSaving = true)
          )
          .catch((e) => {
            this.colorSnack = "red";
            this.mensajeSnack = e.data;
            this.Showsnackbar = true;
          });
      }
    },
    async InsertarCuadrilla() {
      if (this.$refs.form.validate()) {
        this.url = this.$store.getters.urlBase + "Gang/insertgang";

        this.ots = [this.otMantenimientoSeleccion, this.otComercialSeleccion];

        console.log("los empleados son: ");
        console.log(this.empleadoSeleccionados);

        console.log("La contraseña es: ");
        console.log(this.password);

        console.log("la cuenta es: ");
        console.log(this.Usuario);

        console.log("la ot es: ");
        console.log(this.ots);

        var gangModel = {
          EmployeesId: this.empleadoSeleccionados,
          Password: this.password,
          Account: this.Usuario,
          OTId: this.otMantenimientoSeleccion,
        };
        // const config = {
        //   headers: {
        //     Authorization: `Bearer ${this.$store.getters.usuario.token}`,
        //   },
        // };
        await axios
          .post(this.url, gangModel)
          //.post(this.url, gangModel, config)
          .then(
            (response) => (this.respuesta = response),
            (this.isSaving = true)
          )
          .catch((e) => {
            this.colorSnack = "red";
            this.mensajeSnack = e.data;
            this.Showsnackbar = true;
          });
      }
    },
  },
};
</script>
